"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get HRIS_CONNECT_OUTCOMES () {
        return HRIS_CONNECT_OUTCOMES;
    },
    get HRIS_CONNECT_PERMISSION () {
        return HRIS_CONNECT_PERMISSION;
    },
    get HRIS_OAUTH_CONNECT_INTENTS () {
        return HRIS_OAUTH_CONNECT_INTENTS;
    },
    get HRIS_OAUTH_INTENTS () {
        return HRIS_OAUTH_INTENTS;
    },
    get HRIS_OAUTH_PROVIDERS () {
        return HRIS_OAUTH_PROVIDERS;
    },
    get HRIS_SIGN_IN_OUTCOMES () {
        return HRIS_SIGN_IN_OUTCOMES;
    }
});
const HRIS_OAUTH_PROVIDERS = [
    "bamboohr"
];
const HRIS_CONNECT_PERMISSION = "hris_integrations:connectIntegration";
const HRIS_OAUTH_CONNECT_INTENTS = [
    "connect",
    "reconnect"
];
const HRIS_OAUTH_INTENTS = [
    ...HRIS_OAUTH_CONNECT_INTENTS,
    "sso"
];
const HRIS_CONNECT_OUTCOMES = [
    "connected",
    "credentials-reset",
    "already-connected"
];
const HRIS_SIGN_IN_OUTCOMES = [
    "signed-in",
    "sign-in-method-disabled"
];
